const WMS_DEFAULT_FIELD = 'wms:';
const URL_REQUEST_PARAMS = 'service=WMS&version=1.1.0&request=GetMap&layers=';
const URL_CONSTANT = '&styles=&bbox=';
const URL_FORMAT_PARAMS =
  '&width=461&height=768&srs=EPSG:4326&format=application%2Fjson%3Btype%3Dgeojson';

/**
 * Transforms a WMS url into a GeoJSON.
 *
 * @param {object} arg - The object parameter.
 * @param {string} arg.url - The URL of the WMS.
 * @param {Array} arg.bbox - The bbox array.
 * @param {string} arg.wmsLayerNames - The names of the stored WMS layers.
 * @returns {string} The new url.
 * @throws {Error} If something goes wrong.
 */
const getGeoJSONURLFromWMS = ({ url, bbox, wmsLayerNames }) => {
  let adaptedUrl = url;
  const layerNamesArray = wmsLayerNames.split(',');
  if (layerNamesArray.length === 1) {
    const wmsServer = `${url}?`;
    let mainName = `${url.split('/')[4]}:`;
    if (mainName === WMS_DEFAULT_FIELD) mainName = '';
    adaptedUrl = `${wmsServer}${URL_REQUEST_PARAMS}${mainName}${wmsLayerNames}${URL_CONSTANT}${bbox[1]},${bbox[0]},${bbox[3]},${bbox[2]}${URL_FORMAT_PARAMS}`;
  }
  return adaptedUrl;
};

export default getGeoJSONURLFromWMS;
